// extracted by mini-css-extract-plugin
export var bubble = "_2s-0";
export var container = "_2s-f";
export var contrastBorder = "_2s-g";
export var greyOut = "_2s-2";
export var initialsColor0 = "_2s-3";
export var initialsColor1 = "_2s-4";
export var initialsColor10 = "_2s-d";
export var initialsColor11 = "_2s-e";
export var initialsColor2 = "_2s-5";
export var initialsColor3 = "_2s-6";
export var initialsColor4 = "_2s-7";
export var initialsColor5 = "_2s-8";
export var initialsColor6 = "_2s-9";
export var initialsColor7 = "_2s-a";
export var initialsColor8 = "_2s-b";
export var initialsColor9 = "_2s-c";
export var initialsWrapper = "_2s-1";
export var large = "_2s-l";
export var medium = "_2s-k";
export var mediumSmall = "_2s-j";
export var mediumSmallMedium = "_2s-o";
export var micro = "_2s-h";
export var small = "_2s-i";
export var tiny = "_2s-n";
export var xTiny = "_2s-m";